import SystemKeys from "@/common/utils/SystemKeys";
import { LocalStorage } from "@/storage/LocalStorage";
import { StoreItem } from "../services/StoreItemGraphQLService";

export class StoreItemStorage {
  private localStorage = new LocalStorage();

  private itemsToSave: StoreItemsToSave = {
    timestamp: 0,
    storeItems: []
  };

  constructor() {
    const entries = this.localStorage.get(SystemKeys.storedStoreItemsKey);
    if (!!entries) {
      this.itemsToSave = JSON.parse(entries);
    }
  }

  public set storeItems(storeItems: StoreItem[]) {
    this.itemsToSave.storeItems = storeItems.map(si => ({
      changed: false,
      entity: si
    }));
    this.itemsToSave.timestamp = new Date().getTime();
  }

  public get storeItems() {
    return this.itemsToSave.storeItems.map(si => {
      return si.entity;
    });
  }

  public get timestamp() {
    return this.itemsToSave.timestamp;
  }

  public save() {
    this.localStorage.set(
      SystemKeys.storedStoreItemsKey,
      JSON.stringify(this.itemsToSave)
    );
  }

  public getToSyncStoreItems() {
    this.load();
    return this.itemsToSave.storeItems.filter(fe => fe.changed);
  }

  private load() {
    const entries = this.localStorage.get(SystemKeys.storedStoreItemsKey);
    if (!!entries) {
      this.itemsToSave = JSON.parse(entries);
    }
  }
}

interface StoreItemsToSave {
  timestamp: number;
  storeItems: Array<FlaggedEntity<StoreItem>>;
}

interface FlaggedEntity<T> {
  changed: boolean;
  entity: T;
}
